import React from 'react'
import { DisplaysNotificationsMethods, IDisplaysNotificationsProps } from './displays__notifications.local.methods'
import Icon from 'blocks.simple/icon/icon'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import EditText from 'blocks.simple/editText/editText'
import { Radio } from 'atoms/Radio'
import Button from 'blocks.simple/button/button'
import translate from 'core/translate'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { text as textStyles } from 'theme'
import styles from './displays__notifications.jcss'
import { Typography } from 'atoms/Typography'
import { displaysActions } from '../displays.state'
import { connect } from 'react-redux'
import { components, GroupBase, MultiValue as SelectedOptions, MultiValueProps, OptionProps } from 'react-select'
import { MySelect, NotificationEmailOption } from './displays__notifications_multy_select'
import { Scrollbars } from 'react-custom-scrollbars'
import { AppDispatch } from 'core/store'
import { IRootState } from 'core/store/rootReducer'

const scrollBarStyles = {
    width: '100%',
    height: '100%',
}

const Option = (props: OptionProps<NotificationEmailOption, true>) => {
    return (
        <div>
            <components.Option<NotificationEmailOption, true, GroupBase<NotificationEmailOption>> {...props}>
                <input type="checkbox" checked={props.isSelected} onChange={() => null} /> <label>{props.label}</label>
            </components.Option>
        </div>
    )
}

const MultiValue = (props: MultiValueProps<NotificationEmailOption, true>) => (
    <components.MultiValue<NotificationEmailOption, true, GroupBase<NotificationEmailOption>> {...props}>
        <span>{props.data.label}</span>
    </components.MultiValue>
)

const events = [
    { code: 'core_dstatestatustatebecome_offline', key: 'deviceWentOffline' },
    { code: 'core_dstatestatustatebecome_error', key: 'deviceGaveError' },
    { code: 'core_dstatestatustatebecome_online', key: 'deviceWentOnline' },
    { code: 'core_dstatestatustatebecome_screen_off', key: 'screenOffDevice' },
]

const rightEvents = [
    { code: 'deviceOfflineTime', key: 'deviceOfflineNTimes' },
    { code: 'nullValue', key: 'deviceGaveError' },
    { code: 'nullValue1', key: 'deviceWentOnline' },
    { code: 'screenOffTimesDevice', key: 'screenOffNTimesDevice' },
]

const DisplaysNotifications = (p_: IDisplaysNotificationsProps) => {
    const {
        state,
        setState,
        checkedType,
        getCheckedValue,
        getCheckedRightEventsValue,
        setTime,
        applySettings,
    } = DisplaysNotificationsMethods(p_)

    const notificationsEmails = (): NotificationEmailOption[] =>
        p_.notificationsEmail.map((option, index) => ({ id: index, label: option, value: option }))

    const valueEmails = (code: string) => {
        const currentEvent = state.events.find((element) => element.event === code)

        if (currentEvent && currentEvent.emails) {
            return currentEvent.emails.map((event) => {
                return { label: event, value: event }
            })
        }

        return null
    }

    const onChangeHandler = (selected: SelectedOptions<NotificationEmailOption>, code: string) => {
        const emails = selected.map((mail) => mail.value)

        setState((prevState) => ({
            ...prevState,
            events: prevState.events.map((event) => (event.event === code ? { ...event, emails } : event)),
        }))
    }

    return (
        <Scrollbars style={scrollBarStyles}>
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    <Icon type="notifications" containerClass={styles.displaysNotifications__icon} size={30} />
                    <Typography type={'title'} className={styles.displaysNotifications__title}>
                        {translate('notificationsByMail')}
                    </Typography>
                </div>
                <div className={styles.displaysNotifications__content}>
                    <div>
                        <Typography type={'title'} className={styles.displaysNotifications__subTitle}>
                            {translate('typeOfNotification')}
                        </Typography>
                        <div className={styles.selects}>
                            <div className={styles.inputContainer}>
                                <div className={styles.leftColumn}>
                                    {events.map((item, index) => {
                                        return (
                                            <span key={`notification_eventstate${index}`}>
                                                <Checkbox
                                                    className={cn(styles.checkbox)}
                                                    onClick={(checked: boolean) => checkedType(checked, item.code)}
                                                    checked={getCheckedValue(item.code)}
                                                    label={
                                                        <div className={cn(grid.ml_mini)}>{translate(item.key)}</div>
                                                    }
                                                />
                                                <div className={cn(styles.timeLeftInputs)}>
                                                    <MySelect
                                                        isDisabled={!getCheckedValue(item.code)}
                                                        options={notificationsEmails()}
                                                        separator={false}
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        components={{ Option, MultiValue }}
                                                        placeholder={translate('selectMail')}
                                                        onChange={(selected) => {
                                                            onChangeHandler(selected, item.code)
                                                        }}
                                                        allowSelectAll={true}
                                                        value={valueEmails(item.code)}
                                                    />
                                                </div>
                                            </span>
                                        )
                                    })}
                                </div>
                                <div className={styles.rightColumn}>
                                    {rightEvents.map((item, index) =>
                                        index === 1 || index === 2 ? (
                                            <div
                                                className={cn(styles.dNone)}
                                                key={`notification_eventstaterightEventsDnone_${index}`}
                                            >
                                                <Checkbox
                                                    className={cn(styles.checkbox)}
                                                    label={
                                                        <div className={cn(grid.ml_mini)}>{translate(item.key)}</div>
                                                    }
                                                />
                                                <div className={styles.timeInputs}>
                                                    <EditText
                                                        className={cn(grid.mr_big, textStyles.start)}
                                                        mask="99:99:99"
                                                        type="tel"
                                                        placeholder="__:__:__"
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <span key={`notification_eventstaterightEventstate${index}`}>
                                                <Checkbox
                                                    className={cn(styles.checkbox)}
                                                    onClick={(checked: boolean) => checkedType(checked, item.code)}
                                                    checked={getCheckedRightEventsValue(item.code)}
                                                    label={
                                                        <div className={cn(grid.ml_mini)}>{translate(item.key)}</div>
                                                    }
                                                />
                                                <div className={styles.timeInputs}>
                                                    <EditText
                                                        className={cn(grid.mr_big, textStyles.start)}
                                                        onChange={(value: string) => {
                                                            const data =
                                                                index === 0
                                                                    ? {
                                                                          ...state,
                                                                          options: {
                                                                              ...state.options,
                                                                              offlineTime: value,
                                                                          },
                                                                      }
                                                                    : {
                                                                          ...state,
                                                                          options: {
                                                                              ...state.options,
                                                                              screenOffTime: value,
                                                                          },
                                                                      }

                                                            setState((prevState) => ({ ...prevState, ...data }))
                                                        }}
                                                        onBlur={(value: string) =>
                                                            setTime(
                                                                value,
                                                                index === 0 ? 'offlineTime' : 'screenOffTime'
                                                            )
                                                        }
                                                        mask="99:99:99"
                                                        type="tel"
                                                        placeholder="__:__:__"
                                                        value={
                                                            index === 0
                                                                ? state.options.offlineTime
                                                                : state.options.screenOffTime
                                                        }
                                                        disabled={!getCheckedRightEventsValue(item.code)}
                                                    />
                                                </div>
                                            </span>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={grid.mt_big}>
                        <Typography type={'title'} className={styles.displaysNotifications__subTitle}>
                            {translate('notificationTime')}
                        </Typography>
                        <div className={styles.inputs}>
                            <div className={styles.displaysNotifications__inputWrapper_type_startTime}>
                                <EditText
                                    className={cn(grid.mr_big, textStyles.center)}
                                    label={translate('start')}
                                    onChange={(value: string) =>
                                        setState((prevState) => ({ ...prevState, startTime: value }))
                                    }
                                    onBlur={(value: string) => setTime(value, 'startTime')}
                                    mask="99:99:99"
                                    type="tel"
                                    placeholder="__:__:__"
                                    value={state.startTime}
                                />
                            </div>
                            <div className={styles.displaysNotifications__inputWrapper_type_endTime}>
                                <EditText
                                    className={cn(textStyles.center)}
                                    label={translate('ending')}
                                    onChange={(value: string) =>
                                        setState((prevState) => ({ ...prevState, endTime: value }))
                                    }
                                    onBlur={(value: string) => setTime(value, 'endTime')}
                                    mask="99:99:99"
                                    type="tel"
                                    placeholder="__:__:__"
                                    value={state.endTime}
                                />
                            </div>
                        </div>
                        <div className={styles.inputs}>
                            <div className={styles.displaysNotifications__inputWrapper_type_sendInterval}>
                                <EditText
                                    className={cn(textStyles.center)}
                                    label={translate('sendNoMoreOften')}
                                    onChange={(value: string) =>
                                        setState((prevState) => ({ ...prevState, timeoutS: value }))
                                    }
                                    type="number"
                                    value={state.timeoutS}
                                />
                            </div>
                        </div>

                        {p_.selectedInfo && p_.selectedInfo.type === 'group' && (
                            <div className={cn(styles.selects, grid.mt_big)}>
                                <Radio
                                    selected={state.applyRecursively}
                                    onClick={(applyRecursively) =>
                                        setState((prevState) => ({ ...prevState, applyRecursively }))
                                    }
                                    label={translate('applyNotificationsSettingsForAllDisplays')}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.footer}>
                    <div className={cn(grid.row, grid.center)}>
                        <Button rounded="full_md" mod={'withBorder'} onClick={p_.closeModal}>
                            {translate('cancel')}
                        </Button>
                        <Button rounded="full_md" className={cn(grid.ml_md)} mod="fill" onClick={applySettings}>
                            {translate('apply')}
                        </Button>
                    </div>
                </div>
            </div>
        </Scrollbars>
    )
}

const mapStateToProps = (state: IRootState) => {
    return {
        notificationsEmail: state.user.data?.notificationsEmail || [],
    }
}

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
        closeModal: () => dispatch(displaysActions.closeModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplaysNotifications)
